// src/router/index.js
import { createRouter, createWebHistory } from "vue-router";

const routes = [
  { path: "/", name: "Inicio", component: () => import("../views/Inicio.vue") },
  {
    path: "/Productos",
    name: "Productos",
    component: () => import("../views/Productos.vue"),
  },
  {
    path: "/Servicios",
    name: "Servicios",
    component: () => import("../views/Servicios.vue"),
  },
  {
    path: "/nosotros",
    name: "Nosotros",
    component: () => import("../views/Nosotros.vue"),
  },
  {
    path: "/contactenos",
    name: "Contactenos",
    component: () => import("../views/Contactenos.vue"),
  },
  {
    path: "/PQR-Servicios",
    name: "PQRServicios",
    component: () => import("../views/PqrServices.vue"),
  },
  {
    path: "/PQR-Productos",
    name: "PQRProductos",
    component: () => import("../views/PqrProducts.vue"),
  },
  {
    path: "/PQR-Politica-de-Tratamiento-y-Proteccion-de-Datos",
    name: "PoliticaTratamientoDatos",
    component: () => import("../views/PoliticaTratamientoDatos.vue"),
  },

  // 👇 NUEVA: catch-all 404 (NO redirige)
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: () => import("../views/NotFound.vue"),
    meta: { title: "404 — Página no encontrada", robots: "noindex" },
  },
];

const router = createRouter({
  // lo dejo como lo tenías:
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

// (opcional) setear <title> y robots sin librerías extra
router.afterEach((to) => {
  if (to.meta?.title) document.title = to.meta.title;
  const m =
    document.querySelector('meta[name="robots"]') ||
    (() => {
      const el = document.createElement("meta");
      el.setAttribute("name", "robots");
      document.head.appendChild(el);
      return el;
    })();
  m.setAttribute("content", to.meta?.robots || "index,follow");
});

export default router;
